import purebasic from "refractor/purebasic";
export default purebasic;